import { getSessionStorageItemJson } from '@vfde-sails/storage';
import {
    ADDITIONAL_PAGE_OPTIONS,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_HARDWAREONLY,
} from '@vfde-sails/constants';
import {
    APP,
    CONTAINER_HARDWARE_ONLY,
    HARDWARE_ONLY_SWITCH_CONTAINER_ID,
} from '../../../app/constants';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get hardware only status from storage, URL or DOM
 */
export const getHardwareOnly = (): boolean => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;

    const mainStorage = storage?.[SAILS_PARAM_HARDWAREONLY];
    const deviceStorage = storage?.[APP]?.[CONTAINER_HARDWARE_ONLY]?.[deviceId]?.[SAILS_PARAM_HARDWAREONLY];

    if (mainStorage === false) {
        return false;
    }

    return deviceStorage ?? getHardwareOnlyFromDom();
};

/**
 * Get hardware only from DOM
 */
const getHardwareOnlyFromDom = (): boolean => {
    const container = document.getElementById(HARDWARE_ONLY_SWITCH_CONTAINER_ID);
    const checkbox = container?.getElementsByTagName('input')[0];

    return checkbox?.checked || false;
};
